import { Storybook } from "@tento-ui/ui/storybook";
import { StateDot } from "./state-dot";

/** Three claims: the four states are one box, the running one is a stepped
 * trail rather than a rotation, and the settled ones differ only in hue. */
export class StateDotStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · state dot";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "All four states — ongoing, done, error, warn",
        render: () => {
          const $wrap = row();
          for (const state of ["ongoing", "done", "error", "warn"] as const) {
            $wrap.append(labelled(state));
          }
          return $wrap;
        },
      },
      {
        title: "ongoing — the running mark, one 1s cycle, 8 phases",
        render: () => StateDot.makeWith({ state: "ongoing" }),
      },
      {
        title: "done",
        render: () => StateDot.makeWith({ state: "done" }),
      },
      {
        title: "error",
        render: () => StateDot.makeWith({ state: "error" }),
      },
      {
        title: "warn",
        render: () => StateDot.makeWith({ state: "warn" }),
      },
      {
        title: "A column of rows — the box never changes width, whatever the state",
        render: () => {
          const $wrap = document.createElement("div");
          $wrap.style.display = "flex";
          $wrap.style.flexDirection = "column";
          $wrap.style.gap = "6px";
          const rows: [StateDot.State, string][] = [
            ["ongoing", "cargo build -p tento-spool-server"],
            ["done", "html/routes/stream-render.ts"],
            ["error", "deno check html/routes/*.ts"],
            ["warn", "/etc/hosts"],
          ];
          for (const [state, text] of rows) {
            const $line = document.createElement("div");
            $line.style.display = "flex";
            $line.style.alignItems = "center";
            $line.style.gap = "6px";
            const $text = document.createElement("span");
            $text.textContent = text;
            $text.style.fontFamily = "ui-monospace, SFMono-Regular, Menlo, monospace";
            $text.style.fontSize = "12px";
            $text.style.color = "var(--text-ter, #8b93a7)";
            $line.append(StateDot.makeWith({ state }), $text);
            $wrap.append($line);
          }
          return $wrap;
        },
      },
    ];
  }
}

/** The dot beside its own name — the dot is aria-hidden and carries no
 * wording of its own, so a card that shows one has to write the label. */
function labelled(state: StateDot.State): HTMLElement {
  const $cell = document.createElement("div");
  $cell.style.display = "flex";
  $cell.style.flexDirection = "column";
  $cell.style.alignItems = "center";
  $cell.style.gap = "8px";
  const $name = document.createElement("span");
  $name.textContent = state;
  $name.style.fontSize = "11px";
  $name.style.color = "var(--text-ter, #8b93a7)";
  $cell.append(StateDot.makeWith({ state }), $name);
  return $cell;
}

function row(): HTMLElement {
  const $wrap = document.createElement("div");
  $wrap.style.display = "flex";
  $wrap.style.alignItems = "center";
  $wrap.style.gap = "24px";
  return $wrap;
}
